
import { NativeModules } from 'react-native';

export default class AppTrackingTransparencyManager {

  static showAppTrackingPrompt = () => {
    NativeModules.AppTrackingTransparencyManager.requestTrackingAuthorization();
  }
}